import axios from 'axios';
import useAxios, { configure } from 'axios-hooks';
import useTheme from "./useTheme";
export default (function (config, options) {
    var theme = useTheme();
    configure({
        axios: axios.create({
            baseURL: theme.config.cms.endpoint,
        }),
    });
    return useAxios(config, options);
});
//# sourceMappingURL=useCMS.js.map